module.exports = __webpack_public_path__ + "img/47_29.5f2d2e67.png";